import { Outlet, Link } from "react-router-dom";
import { AudioLines, Video, Megaphone, Clapperboard, FileText, IdCard, ListChecks } from "lucide-react";
import { HubShell } from "@/components/layout/HubTabs";
import { Button } from "@/components/ui/button";
import { GuideLink } from "@/components/guides/GuideLink";

// All Studio tools share the same capability (producer_tools), gated at the route.
const TABS = [
  { key: "recordings", label: "Library", to: "/admin/studio/recordings", icon: AudioLines },
  { key: "transcripts", label: "Transcripts", to: "/admin/studio/transcripts", icon: FileText },
  { key: "videos", label: "Videos", to: "/admin/studio/videos", icon: Video },
  { key: "name-tags", label: "Name badges", to: "/admin/studio/name-tags", icon: IdCard },
  { key: "social", label: "Social", to: "/admin/studio/social", icon: Megaphone },
];

export default function StudioHub() {
  return (
    <HubShell
      eyebrow="Library & Tools"
      description="Recordings, transcripts, hosted video, name badges and social posts. Live production happens in the Studio."
      testIdPrefix="studio"
      tabs={TABS}
      actions={(
        <>
          <Button asChild size="sm" className="bg-primary text-primary-foreground hover:bg-[hsl(var(--primary-hover))]" data-testid="studio-open-console-btn">
            <Link to="/studio"><Clapperboard className="mr-2 h-4 w-4" /> Open Studio</Link>
          </Button>
          <GuideLink slug="studio-overview" label="Studio guide" className="hidden sm:inline-flex" />
          <Button asChild variant="outline" size="sm" data-testid="studio-checklist-btn">
            <Link to="/portal/guides/checklist">
              <ListChecks className="mr-2 h-4 w-4" /> Show-day checklist
            </Link>
          </Button>
        </>
      )}
    >
      <Outlet />
    </HubShell>
  );
}
